import { LitElement, html } from "lit-element";
import { property } from "lit/decorators.js";

class ResetPassword extends LitElement {
  errors: any = {};
  token: any;
  @property({ type: String }) message: any;

  static get properties() {
    return {
      errors: { type: Object },
      token: { type: String },
    };
  }

  render() {
    return html`
      <div class="auth-container">
        <h1>Reset Password</h1>

        ${this.errors.field === "top" || this.errors.field === "email_password"
          ? html`<div class="form-error-message is-top">
              ${this.errors.error}
            </div>`
          : ""}
        ${this.message
          ? html`<div class="form-success-message">${this.message}</div>`
          : html`<form @submit="${this.handleSubmit}">
              <div
                class="form-group ${this.errors.field === "password"
                  ? "has-error"
                  : ""}"
              >
                <label for="password">New Password</label>
                <input type="password" name="password" />
                ${this.errors.field === "password"
                  ? html`<span class="form-error-message"
                      >${this.errors.error}</span
                    >`
                  : ""}
              </div>

              <div
                class="form-group ${this.errors.field === "confirmPassword"
                  ? "has-error"
                  : ""}"
              >
                <label for="confirm-password">Confirm New Password</label>
                <input type="password" name="confirm-password" />
                ${this.errors.field === "confirmPassword"
                  ? html`<span class="form-error-message"
                      >${this.errors.error}</span
                    >`
                  : ""}
              </div>

              <div class="form-submit-section">
                <button type="submit" class="form-submit form-button">
                  <span>Reset Password</span>
                </button>
              </div>
            </form>`}

        <p class="form-message">
          Remember your password?
          <a href="/" class="login-link">Login</a>
        </p>
      </div>
    `;
  }

  handleSubmit(event) {
    event.preventDefault();
    const form = event.target;
    const formData = new FormData(form);
    const password = formData.get("password");
    const confirmPassword = formData.get("confirm-password");

    const requestData = { password, confirmPassword, token: this.token };

    fetch(`${process.env.BASE_API_URL}/reset-password`, {
      method: "POST",
      body: JSON.stringify(requestData),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.error) {
          this.errors = data;
        } else {
          this.message = data.message;
        }
      })
      .catch((error) => {
        console.error("Error during password reset:", error);
        alert("An error occurred. Please try again later.");
      });
  }

  protected createRenderRoot() {
    return this;
  }

  // You can get the token from the URL (example: ?reset-token=xyz)
  connectedCallback() {
    super.connectedCallback();
    const urlParams = new URLSearchParams(window.location.search);
    this.token = urlParams.get("token");
  }
}

customElements.define("reset-password-page", ResetPassword);
